import { render, staticRenderFns } from "./WaterGateShow.vue?vue&type=template&id=55d6ed25&"
import script from "./WaterGateShow.vue?vue&type=script&lang=js&"
export * from "./WaterGateShow.vue?vue&type=script&lang=js&"
import style0 from "./WaterGateShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports